export default "__VITE_ASSET__f9090e04__"